import { useNavigationContext } from 'hooks';
import { allowedActionsStore } from 'store';

export const useAllowedActions = () => {
  const { organisationId, countryId, centreId, locationId } = useNavigationContext();

  const {
    isLoading,
    isFetching,
    data: allowedActions,
  } = allowedActionsStore.service.useGetAllowedActionsQuery({
    organisationId,
    countryId,
    centreId,
    locationId,
  });

  return {
    canEditExamDatesForLocations: allowedActions?.canEditExamDatesForLocations ?? false,
    canCreateLrwSession: allowedActions?.canCreateLrwSession ?? false,
    canCreateSpeakingSession: allowedActions?.canCreateSpeakingSession ?? false,
    canViewExamDatesForLocations: allowedActions?.canViewExamDatesForLocations ?? false,
    canViewLrwSession: allowedActions?.canViewLrwSession ?? false,
    canViewSpeakingSession: allowedActions?.canViewSpeakingSession ?? false,
    isLoading,
    isFetching,
  };
};
